import { render, staticRenderFns } from "./CreateTagForm.vue?vue&type=template&id=03f5fe13&"
import script from "./CreateTagForm.vue?vue&type=script&lang=js&"
export * from "./CreateTagForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports